import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { take } from "rxjs/operators";
import { PhoneService } from "../../../../../common/services/api/resources/phone/phone.service";
import { PhoneItemInfo } from "../phone-admin-page.component";
import timezones from "../../../../../common/interfaces/timezones";
import { ModalMaterialComponent } from "../../../shared/components/modal/modal-material.component";
import { PhoneFeatures } from "@onsip/common/interfaces/phone-info";

@Component({
  selector: "onsip-phone-info",
  templateUrl: "./phone-info.component.html",
  styleUrls: ["./phone-info.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PhoneInfoComponent implements OnDestroy, OnInit {
  @Input() phoneInfo!: PhoneItemInfo;
  @Input() phoneFeatures!: PhoneFeatures;
  @Input() noFeatures!: boolean;
  @Output() editPanel = new EventEmitter<void>();

  // descriptive text for timezone - retrieve from timezones interface
  displayTimezone!: string;
  // remote aor for test call
  remoteAor = "";

  private unsubscriber = new Subscription();

  constructor(private dialog: MatDialog, private phoneService: PhoneService) {}

  ngOnInit(): void {
    this.displayTimezone =
      timezones.timezoneOptions.find(
        timezone => parseFloat(timezone.value) === parseInt(this.phoneInfo.gmtOffset) / 3600
      )?.text || "false";

    this.remoteAor =
      this.phoneInfo.assignedUserAddresses.find(address => address.line === "1")?.userAddress.aor ||
      "";
  }

  ngOnDestroy(): void {
    this.unsubscriber.unsubscribe();
  }

  toggleInfoPanel(): void {
    this.editPanel.emit();
  }

  openKeyResetDialog(): void {
    const dialog = this.dialog.open(ModalMaterialComponent, {
      panelClass: ["mat-typography", "onsip-dialog-universal-style"],
      data: {
        title: "Update Security Key",
        message:
          "If you have reset your phone to factory default, you need to generate a new security key to connect the phone to OnSIP's server. This will allow you to manage the phone from OnSIP's admin app.",
        primaryBtnText: "Confirm",
        primaryBtnFlat: true
      }
    });
    this.unsubscriber.add(
      dialog
        .afterClosed()
        .pipe(take(1))
        .subscribe(response => {
          if (response && response.doPrimaryAction) {
            this.phoneService.phoneRemoveEncryptionKey(this.phoneInfo.phoneId);
          }
        })
    );
  }
}
